import { ApolloLink as a, Observable as w, HttpLink as $, ApolloClient as D, InMemoryCache as G, ApolloProvider as F } from "@apollo/client";
import { onError as Q } from "@apollo/client/link/error";
import { asyncMap as E } from "@apollo/client/utilities";
import z from "../../../common-lib/hooks/metadata/useInjectMetadata.js";
import { ApiContextOptions as B } from "../../constants/apollo.js";
import { ERROR_CODE as y } from "../../constants/error.js";
import { SHARE_OPERATIONS_WITH_AUTH as N } from "../../constants/graphql.js";
import { AssetType as M } from "../../constants/url.js";
import { useConfigContext as J } from "../config/ConfigContext.js";
import { useLogicControlContext as U } from "../share/LogicControlContext.js";
import { CustomError as K } from "../../errors/customError.js";
import { renewAccessToken as W } from "../../graphql/helper/refreshToken.js";
import V from "../../hooks/errors/useErrorHandler.js";
import X from "../../hooks/generic/useApeironPathMaker.js";
import { getAccessToken as Y } from "../../util/authenication/index.js";
import * as i from "ramda";
import { useRef as Z, useCallback as p, useMemo as c, useEffect as tt } from "react";
import { jsx as et } from "react/jsx-runtime";
const At = (P) => {
  const {
    children: T
  } = P, {
    config: j
  } = J(), {
    apollo: e
  } = j, {
    makePath: l
  } = X(), {
    setForceLogout: f,
    setGeneralError: h
  } = U(), {
    getErrorMessage: k
  } = V(), {
    fetchMetadata: x,
    injectMetadata: g,
    injectMetadataLegacyMode: O
  } = z(), d = Z({
    authOperations: i.concat(N, (e == null ? void 0 : e.authOperations) || []),
    buildId: (e == null ? void 0 : e.buildId) || "",
    domains: {
      api: (e == null ? void 0 : e.domain) || "",
      json: l(M.Json, ""),
      login: (e == null ? void 0 : e.domainLogin) || ""
    }
  }), b = p((t) => i.includes(t.operationName, d.current.authOperations), []), A = p((t) => {
    var u;
    const {
      operation: o
    } = t, n = "operation" in o.query.definitions[0] && ((u = o.query.definitions[0]) == null ? void 0 : u.operation) || "", r = o.operationName || "", s = o.getContext()[B.SkipError] || !1;
    if (n === "mutation" && !s) {
      const m = k(t);
      h(m), console.error(`Api | ${r} | ${m}`);
    }
  }, [k, h]), L = p((t) => {
    const {
      networkError: o
    } = t;
    o && i.pathOr(0, ["result", "errors", 0, "extensions", "subCode"], o) === y.GRAPHQL.FORCE_LOGOUT && f(!0);
  }, [f]), I = p((t) => {
    A(t), L(t);
  }, [A, L]), R = c(() => new a((t, o) => i.isNotNil(e) ? o(t) : new w((n) => {
    n.next({
      data: null
    }), n.complete();
  })), [e]), H = c(() => new a((t) => {
    const {
      domain: o
    } = t.getContext(), {
      api: n,
      login: r
    } = d.current.domains;
    return new $({
      uri: o || n,
      credentials: "same-origin",
      fetch: async (u, m) => {
        await x();
        const C = await W(r);
        return C ? fetch(u, i.assocPath(["headers", "authorization"], `Bearer ${C}`, m)) : fetch(u, m);
      }
    }).request(t);
  }), []), _ = c(() => new a((t, o) => {
    const n = b(t), r = Y();
    return n && i.isNil(r) ? new w((s) => {
      s.error(new K("Skip calling due to missing access token", y.GRAPHQL.NO_ACCESS_TOKEN));
    }) : (t.setContext(({
      headers: s = {}
    }) => ({
      headers: {
        ...s,
        authorization: r ? `Bearer ${r}` : null
      }
    })), o(t));
  }), []), S = c(() => new a((t, o) => E(o(t), async (n) => i.isNotNil(n.data) ? i.assoc("data", O(n.data), n) : n)), [O]), q = c(() => new a((t, o) => E(o(t), async (n) => {
    const {
      buildId: r
    } = d.current;
    return await g(n, r);
  })), [g]), v = c(() => {
    const t = Q(I);
    return new D({
      cache: new G(),
      defaultOptions: {
        watchQuery: {
          fetchPolicy: "no-cache"
        },
        query: {
          fetchPolicy: "no-cache"
        },
        mutate: {}
      },
      link: a.from([R, t, S, q, _, H])
    });
  }, []);
  return tt(() => {
    i.isNotNil(e) && (d.current = {
      authOperations: i.concat(N, e.authOperations),
      buildId: e.buildId,
      domains: {
        api: e.domain,
        json: l(M.Json, ""),
        login: e.domainLogin
      }
    });
  }, [e, l]), /* @__PURE__ */ et(F, {
    client: v,
    children: T
  });
};
export {
  At as ApolloProvider
};
//# sourceMappingURL=ApolloProvider.js.map
